import { alpha, Paper, PaperProps, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import React, { FC } from 'react';

type Props = PaperProps & {
  withShadow?: boolean;
  small?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
};

// @ts-expect-error: Ref types are incompatible
export const RoundedPaper: FC<React.PropsWithChildren<Props>> = React.forwardRef(
  ({ withShadow, small, children, sx = [], className, ...otherProps }, ref) => {
    const theme = useTheme();
    return (
      <Paper
        className={className}
        {...otherProps}
        elevation={0}
        sx={[
          {
            borderRadius: small ? '8px' : '16px',
            boxShadow: withShadow ? getPaperBoxShadow(theme, small) : undefined,
            border: withShadow ? `1px solid ${theme.palette.grey[50]}` : undefined,
            overflow: 'hidden'
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
        ref={ref}
      >
        {children}
      </Paper>
    );
  }
);

const getPaperBoxShadow = (theme: Theme, small = false) =>
  small
    ? `2px 2px 4px ${alpha(theme.palette.primary.light, 0.5)}`
    : `4px 4px 8px ${alpha(theme.palette.primary.light, 0.5)}`;
